export const BILL_STATUS = [
  { id: "draft", name: "Draft" },
  { id: "submit", name: "Submit" },
  { id: "deleted", name: "Deleted" },
  { id: "approved", name: "Approved" },
  { id: "paid", name: "Paid" },
  { id: "voided", name: "Voided" },
];
